//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import directHeading from "~/components/content/direct/directHeading.vue";
import directSection from "~/components/content/direct/directSection.vue";
import directActionsBlock from "~/components/content/direct/directActionsBlock.vue";

export default {
  name: "directSectionExtras",
  components: {
    directHeading,
    directSection,
    directActionsBlock,
  },
  data() {
    return {
      texts: [
        "Gratis huurtegoed t.w.v. €4,99 / mnd",
        "Een website zonder reclames",
        "Exclusieve winacties",
        "Invloed op de films die wij maken",
      ],
    };
  },
};
